module.exports = {"name":"New Endpoints","release":"2017-08-08","__content":"<!--\n    This section contains the content of the log. You can use markdown here.\n\n    Please don't use heading markup as it clashes with the rest of the page.\n    If you absolutely HAVE to, please use #### Heading 4 or above.\n-->\n<ul>\n<li>Added new endpoints to get and update <a href=\"/api/Tags#get-manage-posttags\">User Tags</a> and <a href=\"/api/Tags#get-manage-usertags\">Post Tags</a>.</li>\n</ul>\n"}


//////////////////
// WEBPACK FOOTER
// ./src/changelog/logs/2017-08-08_Test.md
// module id = 659
// module chunks = 1